import { render, staticRenderFns } from "./Slide4.vue?vue&type=template&id=e607cae0&scoped=true&"
import script from "./Slide4.vue?vue&type=script&lang=js&"
export * from "./Slide4.vue?vue&type=script&lang=js&"
import style0 from "./Slide4.vue?vue&type=style&index=0&id=e607cae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e607cae0",
  null
  
)

export default component.exports